import {Date} from './styled';

export function DatePicker(props){

   const {value,onChange,className,onClick} = props;
 
    return(
        <Date type="date" className={className} name="bday" onClick={onClick} onChange={(e)=>onChange(e.target.value)} value={value}/>
    );  
}